module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Light-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Light-webfont.eot
// module id = 689
// module chunks = 0